import { useTLang } from '../../../../../intl/intl';

export function useStartupPrinterBannerLang() {
  return {
    msg: useTLang({ id: 'startupNotifications.printer.banner.msg' }),
    cta: useTLang({ id: 'startupNotifications.printer.banner.link.cta' }),
  };
}
